export default function VisitorPage() {
	return <div>Ciao</div>;
}
